import { render, staticRenderFns } from "./CurrentHoldingsSummaryPanel.vue?vue&type=template&id=1c697d64&scoped=true"
import script from "./CurrentHoldingsSummaryPanel.vue?vue&type=script&lang=ts"
export * from "./CurrentHoldingsSummaryPanel.vue?vue&type=script&lang=ts"
import style0 from "./CurrentHoldingsSummaryPanel.vue?vue&type=style&index=0&id=1c697d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c697d64",
  null
  
)

export default component.exports